// Older records can contain provider errors in fields intended for publishable text.
export function isDraftFailure(value) {
  const text = typeof value === "string" ? value.trim() : "";
  return /^(?:\[?(?:error|generation failed|failed to generate|AI generation failed)\b|litellm\.|Budget has been exceeded|Error code:\s*\d{3})/i.test(text)
    || /(?:BudgetExceededError|AuthenticationError|RateLimitError|litellm\.exceptions|\b(?:sk-[a-zA-Z0-9_-]{12,})\b)/i.test(text);
}

export function usableDraftText(value) {
  return typeof value === "string" && !isDraftFailure(value) ? value.trim() : "";
}

export function draftText(draft) {
  if (!draft) return "";
  const variants = draft.variants || [];
  const selected = variants.find((v) => v.variant_id === draft.selected_variant_id) || variants[0];
  // The API uses an empty edited_comment to mean no manual edit.
  return draft.edited_comment || selected?.comment_text || draft.generated_comment || "";
}

export function draftState(draft) {
  if (draft?.status === "used") return "Done";
  if (draft?.status === "skipped") return "Skipped";
  const value = draftText(draft);
  if (isDraftFailure(value)) return "Needs repair";
  return usableDraftText(value) ? "Ready to review" : "Needs a draft";
}

export function variantLabel(style) {
  const labels = { one_liner: "One line", one_liner_mid: "Short observation", self_jab: "Self-deprecating", story: "Personal story", question: "Question", insight: "Insight", contrarian: "Different perspective" };
  return labels[style?.toLowerCase()] || (style || "Draft").replace(/[_-]+/g, " ").replace(/^./, (c) => c.toUpperCase());
}
